<template>
  <v-container fluid class="pa-4 rtl">
    <!-- Header -->
    <v-card class="header-card mb-4" elevation="2">
      <div class="d-flex align-center justify-space-between flex-wrap ga-3">
        <div>
          <div class="text-h5 font-weight-bold" style="color: #4a4f55">
            التدريب والمهارات واحتياجات CPD
          </div>
          <div class="text-body-2 text-grey-darken-1 mt-1">
            تقييم مستوى التدريب والاحتياجات التطويرية
          </div>
        </div>
        <v-btn
          prepend-icon="mdi-arrow-right"
          variant="text"
          style="color: #4a4f55"
          @click="showView('pillar-workforce')"
        >
          رجوع
        </v-btn>
      </div>
    </v-card>

    <!-- KPIs -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">32%</div>
          <div class="kpi-label">تلقوا تدريباً خلال 12 شهر</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">68%</div>
          <div class="kpi-label">يحتاجون تدريباً عاجلاً</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card primary">
          <div class="kpi-value">4</div>
          <div class="kpi-label">مجالات بأولوية تدريبية</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">0</div>
          <div class="kpi-label">برامج CPD منتظمة</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-card class="table-card" elevation="1">
      <div class="table-header">احتياجات التدريب حسب المرفق والمجال</div>
      <v-table class="custom-table">
        <thead>
          <tr>
            <th>المرفق</th>
            <th>EMOC/AMTSL</th>
            <th>IPC و IFHS</th>
            <th>إدارة الطوارئ</th>
            <th>DHIS2/بيانات</th>
            <th>نسبة مدربين%</th>
            <th>أولوية التدريب</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in facilities" :key="item.name">
            <td class="font-weight-bold">{{ item.name }}</td>
            <td>
              <v-chip
                :color="chipColor(item.emoc)"
                size="small"
                variant="flat"
                >{{ item.emoc }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="chipColor(item.ipc)"
                size="small"
                variant="flat"
                >{{ item.ipc }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="chipColor(item.emergency)"
                size="small"
                variant="flat"
                >{{ item.emergency }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="chipColor(item.dhis2)"
                size="small"
                variant="flat"
                >{{ item.dhis2 }}</v-chip
              >
            </td>
            <td class="font-weight-bold">{{ item.trainedRate }}</td>
            <td>
              <v-chip
                :color="priorityColor(item.priority)"
                size="small"
                variant="flat"
                >{{ item.priority }}</v-chip
              >
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </v-container>
</template>

<script setup>
const facilities = [
  {
    name: "مستشفى الصداقة التعليمي",
    emoc: "جزئي",
    ipc: "جزئي",
    emergency: "جزئي",
    dhis2: "لا يوجد",
    trainedRate: "35%",
    priority: "شديد",
  },
  {
    name: "مستشفى الأمراض النفسية",
    emoc: "لا يوجد",
    ipc: "لا يوجد",
    emergency: "لا يوجد",
    dhis2: "لا يوجد",
    trainedRate: "15%",
    priority: "شديد",
  },
  {
    name: "مجمع الشيخ عثمان",
    emoc: "جزئي",
    ipc: "جزئي",
    emergency: "كامل",
    dhis2: "جزئي",
    trainedRate: "42%",
    priority: "متوسط",
  },
  {
    name: "مركز كود العثماني",
    emoc: "كامل",
    ipc: "كامل",
    emergency: "جزئي",
    dhis2: "جزئي",
    trainedRate: "60%",
    priority: "خفيف",
  },
  {
    name: "مركز الممدارة",
    emoc: "كامل",
    ipc: "كامل",
    emergency: "كامل",
    dhis2: "جزئي",
    trainedRate: "65%",
    priority: "خفيف",
  },
  {
    name: "مركز المحاريق",
    emoc: "لا يوجد",
    ipc: "جزئي",
    emergency: "لا يوجد",
    dhis2: "لا يوجد",
    trainedRate: "28%",
    priority: "شديد",
  },
  {
    name: "مركز عبد القوي",
    emoc: "كامل",
    ipc: "كامل",
    emergency: "كامل",
    dhis2: "جزئي",
    trainedRate: "62%",
    priority: "خفيف",
  },
  {
    name: "مركز ماري ستبوس",
    emoc: "لا يوجد",
    ipc: "لا يوجد",
    emergency: "لا يوجد",
    dhis2: "لا يوجد",
    trainedRate: "10%",
    priority: "شديد",
  },
  {
    name: "جمعية حقوق الطفل",
    emoc: "جزئي",
    ipc: "جزئي",
    emergency: "لا يوجد",
    dhis2: "لا يوجد",
    trainedRate: "25%",
    priority: "متوسط",
  },
];

const chipColor = (value) => {
  if (value === "كامل") return "green";
  if (value === "جزئي") return "orange";
  return "red";
};

const priorityColor = (value) => {
  if (value === "خفيف") return "green";
  if (value === "متوسط") return "orange";
  return "red";
};

const showView = (view) => console.log("Go to:", view);
</script>

<style scoped>
.rtl {
  direction: rtl;
}

.header-card {
  border-right: 5px solid #4a4f55;
  border-radius: 18px;
  padding: 20px;
}

.kpi-card {
  border-radius: 18px;
  padding: 20px;
  text-align: center;
}

.kpi-value {
  font-size: 34px;
  font-weight: 800;
}

.kpi-label {
  margin-top: 6px;
  font-size: 13px;
}

.primary {
  background: #f0f1f2;
  color: #4a4f55;
}

.danger {
  background: #fdecea;
  color: #c0392b;
}

.warning {
  background: #fff4e5;
  color: #d4821a;
}

.table-card {
  border-radius: 18px;
  overflow: hidden;
}

.table-header {
  padding: 18px;
  font-size: 18px;
  font-weight: 700;
  color: #3a3f47;
  border-bottom: 1px solid #eee;
}

.custom-table {
  direction: rtl;
}

:deep(th) {
  font-weight: 800 !important;
  color: #3a3f47 !important;
  white-space: nowrap;
}

:deep(td) {
  font-size: 14px;
  white-space: nowrap;
}
</style>
